
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import * as actions from '../action';

function SuccessModal() {

  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    sessionStorage.removeItem('status');
  };

  return (
    <Modal.Body>
      <div className="content">
        <div className="login-box">
          <div className="mt-5 w-96">
            <div className="flex flex-col space-y-1 items-center">
              <div className="text-center">
                <i
                  className="fas fa-check-circle fa-5x"
                  style={{ color: '#2DA700' }}
                />
              </div>
              <div className="mt-5 text-center">
                <p style={{ color: '#1B2560'}} className="history-color font-weight-bold">Two-factor authentication is on</p>
              </div>
              <p className="text-center mt-3 mb-0 history-color text-small">We&apos;ll ask for a code if we notice
                an attempted login from an unrecognized device or browser.
              </p>
            </div>
            <div className="pt-5 text-center">
              <button type="submit" className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-block" onClick={closeModal}>
                Done
              </button>
            </div>

          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

SuccessModal.propTypes = {
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(SuccessModal);